export const SET_ROOM_IS_ACTIVE = 'SET_ROOM_IS_ACTIVE';
export const SET_CONVERSATION_INFO = 'SET_CONVERSATION_INFO';
export const SET_CHAT_USER = 'SET_CHAT_USER';
export const SET_ME_RESOLVED = 'SET_ME_RESOLVED';
export const ADD_NEW_MESSAGE = 'ADD_NEW_MESSAGE';
export const EDIT_MESSAGE = 'EDIT_MESSAGE';
export const UPDATE_GUEST_IS_TYPING = 'UPDATE_GUEST_IS_TYPING';
export const UPDATE_USER_IS_PAUSED = 'UPDATE_USER_IS_PAUSED';
export const SET_USERS = 'SET_USERS';
export const SET_MESSAGES = 'SET_MESSAGES';
export const RESET_DATA = 'RESET_DATA';
export const CHANGE_FONT_SETTING = 'CHANGE_FONT_SETTING';
export const SET_SETTINGS_USER = 'SET_SETTINGS_USER';
export const SET_CURRENT_MODE = 'SET_CURRENT_MODE';
export const CHANGE_IS_PAUSED_RECOGNITION = 'CHANGE_IS_PAUSED_RECOGNITION';
export const CHANGE_IS_ACTIVE_RECOGNITION = 'CHANGE_IS_ACTIVE_RECOGNITION';
export const CHANGE_IS_CAMERA_DOUBLE_WIDTH = 'CHANGE_IS_CAMERA_DOUBLE_WIDTH';
export const CHANGE_USER_AUDIO_DEVICE_STATUS = 'CHANGE_USER_AUDIO_DEVICE_STATUS';
export const CHANGE_USER_VIDEO_DEVICE_STATUS = 'CHANGE_USER_VIDEO_DEVICE_STATUS';
export const SET_IS_SIGNER_GUIDE_ACCEPTED = 'SET_IS_SIGNER_GUIDE_ACCEPTED';
export const SET_RECOGNITION_MODELS = 'SET_RECOGNITION_MODELS';
